<div class="order-contact-success">
  <h1 class="success-title">{{ 'order-contact.order-contact-success.made-it' | translate }}</h1>
  <mat-card class="success-message">
    {{ 'order-contact.order-contact-success.success-contact-information' | translate }}
    @if(case(); as caseDto) {
      <span>
        {{ 'order-contact.order-contact-success.success-contact-information-data' | translate: { day: parsedDay(), hour: time(), currency: 'currency' | translate: { amount: caseDto.balance | number: '1.2-2' : 'fr-FR'},  caseNumber: caseDto.presentCreditorShortName } }}
      </span>
    }
  </mat-card>
</div>